import { render } from "./hiddenHotspot.vue?vue&type=template&id=259b0c81"
import script from "./hiddenHotspot.vue?vue&type=script&lang=js"
export * from "./hiddenHotspot.vue?vue&type=script&lang=js"

import "./hiddenHotspot.vue?vue&type=style&index=0&id=259b0c81&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__